module.exports = __webpack_public_path__ + "img/arrow-left.96ebce5f.svg";